var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "#257016",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12C20 7.58172 16.4183 4 12 4ZM23.6139 15.2106C24.0499 15.5497 24.1284 16.178 23.7894 16.6139L19.1227 22.6139C18.9485 22.8379 18.6875 22.9773 18.4045 22.9975C18.1216 23.0177 17.8434 22.9167 17.6392 22.7198L15.3059 20.4698C14.9083 20.0865 14.8968 19.4534 15.2802 19.0559C15.6635 18.6583 16.2966 18.6468 16.6941 19.0302L18.2268 20.5081L22.2106 15.3861C22.5497 14.9501 23.178 14.8716 23.6139 15.2106ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V12C11 12.2652 11.1054 12.5196 11.2929 12.7071L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13 11.5858V6Z",
    fill: "#257016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoclock);
export default __webpack_public_path__ + "static/media/autoclock.ddf07c47b3ebfc50fd36601dc9781df4.svg";
export { ForwardRef as ReactComponent };